import {Component, Input, OnInit} from '@angular/core';
import {RewardService} from "../../../shared/services/reward.service";
import {RewardsSummaryService} from "../../../shared/services/rewards-summary.service";
import {ParamService} from "../../../shared/services/param.service";
import {AuthService} from "../../../shared/services/auth.service";
import {PointsModalService} from "../../../shared/services/points-modal.service";
declare const $: any;
@Component({
  selector: 'app-boost-your-points',
  templateUrl: './boost-your-points.component.html',
  styleUrls: ['./boost-your-points.component.scss']
})
export class BoostYourPointsComponent implements OnInit {

  @Input() enableCashReward: boolean;
  @Input() pointScoreCardFlow: boolean;
  @Input() userInfo: any;
  @Input() appHostURL: any;
  @Input() currentEnvironment: any;
  @Input() rewardsResponseObj;
  b4UGalleryData: any;
  boostYourPointsData: any;
  public showLoading = true;
  public error = false;
  public errorMessage: string;
  public rewardCardDisabled = false;
  isBoostYourPointsCardFlow = true;


  constructor(public _rewardGridService: RewardService,
              private _rewardSummaryService: RewardsSummaryService,
              private paramService: ParamService,
              private authService: AuthService,
              private pointsModalService: PointsModalService) {
    this.rewardCardDisabled = false;
  }

  ngOnInit(): void {
    this._init();
  }

  private _init() {
    this.b4UGalleryData = JSON.parse(localStorage.getItem('abRewards')).offers || [];
    this.getBoostYourPointsData();
    if (this.b4UGalleryData.length > 0) {
      const rewardsObj = this.rewardsResponseObj;
      this.showLoading = false;
      this.focusOnRewardGrid();
    } else {
      this._showError();
    }
  }

  private getBoostYourPointsData() {
    this.currentEnvironment = this._rewardSummaryService.getEnvironment();
    this._rewardGridService.getPointForServicesOffers(this.currentEnvironment, this.userInfo).subscribe(data => {
         this.showLoading = false;
         this.boostYourPointsData =  data ? data['offers'] : [];
         this.boostYourPointsData.map(reward => {
         reward['title'] = reward['brand'];
         reward['offerPrice'] = reward['forUDescription'];
         reward['groceryRewardId'] = reward['offerId'];
         this.analyticsEvents();
         });
       }, error => {
          this.showLoading = false;
          this.analyticsEvents('No Point boosters available at this time');
          return [];
     });
  }

  private focusOnRewardGrid() {
    if ($('reward-grid') && typeof $('reward-grid').ready !== 'undefined') {
      $('reward-grid').ready(() => {
        const focusItem = localStorage.getItem('rewardFocus');
        if (focusItem !== '') {
          $(`[data-focus="${focusItem}"]`).focus();
          localStorage.setItem('rewardFocus', '');
        }
      });
    }
  }

  private _showError() {
    this.showLoading = false;
    this.error = true;
    this.errorMessage = 'Sorry, we\'re having technical difficulties and working on fixing them, please check back later.';
    if (window['AB'] && window['AB']['DATALAYER']) {
      window['AB']['DATALAYER'].setError('no-value', 'boost-your-points|error', this.errorMessage);
    }
  }

  private _isRegistered(): boolean {
    return (this.authService.isTokenValidForSession(this.userInfo));
  }

  openRewardsPage() {
    if (window['AB'] && window['AB']['DATALAYER']) {
      window['AB']['DATALAYER'].analyticsCTATracking('cta:rewards|linkclick|boost-your-points:start-earning');
    }
    window.location.href ='/rewards/dashboard';
  }

  private analyticsEvents(message?:string) {
    if (window['AB'] && window['AB']['DATALAYER'] && localStorage.getItem('analyticsTabClicked')) {
      window['AB']['DATALAYER'].initAngularSPA('rewards', 'dashboard', 'boostyourpoints', undefined, message);
      localStorage.removeItem('analyticsTabClicked');
    }
  }

  triggerBoostYourPointsApi () {
    this._init();
  }

}
